webpackJsonp([142954491611909],{

/***/ 415:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var Gell1 = "https://winpeforum.com/assets/gelleryimages/JIT_1760.png";
	var Gell2 = "https://winpeforum.com/assets/gelleryimages/JIT_1780.png";
	var Gell3 = "https://winpeforum.com/assets/gelleryimages/JIT_1802.png";
	var Gell4 = "https://winpeforum.com/assets/gelleryimages/JIT_1811.png";
	var Gell5 = "https://winpeforum.com/assets/gelleryimages/JIT_1847.png";
	var Gell6 = "https://winpeforum.com/assets/gelleryimages/JIT_1852.png";
	var Gell7 = "https://winpeforum.com/assets/gelleryimages/JIT_1866.png";
	var Gell8 = "https://winpeforum.com/assets/gelleryimages/JIT_1868.png";
	var Gell9 = "https://winpeforum.com/assets/gelleryimages/JIT_1870.png";
	var Gell10 = "https://winpeforum.com/assets/gelleryimages/JIT_1879.png";
	var Gell11 = "https://winpeforum.com/assets/gelleryimages/JIT_1887.png";
	var Gell12 = "https://winpeforum.com/assets/gelleryimages/JIT_1897.png";
	var Gell13 = "https://winpeforum.com/assets/gelleryimages/JIT_1899.png";
	var Gell14 = "https://winpeforum.com/assets/gelleryimages/JIT_1912.png";
	var Gell15 = "https://winpeforum.com/assets/gelleryimages/JIT_1915.png";
	var Gell16 = "https://winpeforum.com/assets/gelleryimages/JIT_1928.png";
	var Gell17 = "https://winpeforum.com/assets/gelleryimages/JIT_1931.png";
	var Gell18 = "https://winpeforum.com/assets/gelleryimages/JIT_1979.png";
	var Gell19 = "https://winpeforum.com/assets/gelleryimages/JIT_1981.png";
	var Gell20 = "https://winpeforum.com/assets/gelleryimages/JIT_2008.png";
	var Gell21 = "https://winpeforum.com/assets/gelleryimages/JIT_2014.png";
	var Gell22 = "https://winpeforum.com/assets/gelleryimages/JIT_2026.png";
	var Gell23 = "https://winpeforum.com/assets/gelleryimages/JIT_2034.png";
	var Gell24 = "https://winpeforum.com/assets/gelleryimages/JIT_2038.png";
	var Gell25 = "https://winpeforum.com/assets/gelleryimages/JIT_2039.png";
	var Gell27 = "https://winpeforum.com/assets/gelleryimages/JIT_2081.png";
	var Gell28 = "https://winpeforum.com/assets/gelleryimages/JIT_2082.png";
	var Gell29 = "https://winpeforum.com/assets/gelleryimages/JIT_2116.png";
	var Gell30 = "https://winpeforum.com/assets/gelleryimages/JIT_2124.png";
	var Gell31 = "https://winpeforum.com/assets/gelleryimages/JIT_1725.jpg";
	
	var Gell32 = "https://winpeforum.com/assets/gelleryimages/win1.jpg";
	var Gell33 = "https://winpeforum.com/assets/gelleryimages/win2.jpg";
	var Gell34 = "https://winpeforum.com/assets/gelleryimages/win3.jpg";
	var Gell35 = "https://winpeforum.com/assets/gelleryimages/win4.jpg";
	var Gell36 = "https://winpeforum.com/assets/gelleryimages/win5.jpg";
	
	var Gell37 = "https://winpeforum.com/assets/gelleryimages/proclub_Screen_shots_01.jpg";
	var Gell38 = "https://winpeforum.com/assets/gelleryimages/proclub_Screen_shots_02.jpg";
	var Gell39 = "https://winpeforum.com/assets/gelleryimages/proclub_Screen_shots_04.jpg";
	
	var Gell40 = "https://winpeforum.com/assets/gelleryimages/Investor_01.jpg";
	var Gell41 = "https://winpeforum.com/assets/gelleryimages/Investor_02.jpg";
	
	var bii1 = "https://winpeforum.com/assets/elements/bii-pic-01.jpg";
	var bii2 = "https://winpeforum.com/assets/elements/bii-pic-02.jpg";
	var bii3 = "https://winpeforum.com/assets/elements/bii-pic-03.jpg";
	
	var iama1 = "https://winpeforum.com/assets/ignite/gallery_pics-01.jpg";
	var iama2 = "https://winpeforum.com/assets/ignite/gallery_pics-02.jpg";
	var iama3 = "https://winpeforum.com/assets/ignite/gallery_pics-03.jpg";
	
	var allImages = [{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell31
	}, {
	  id: 1,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell1
	}, {
	  id: 2,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell2
	}, {
	  id: 3,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell3
	}, {
	  id: 4,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell4
	}, {
	  id: 5,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell5
	}, {
	  id: 6,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell6
	}, {
	  id: 7,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell7
	}, {
	  id: 8,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell8
	}, {
	  id: 9,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell9
	}, {
	  id: 10,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell10
	}, {
	  id: 11,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell11
	}, {
	  id: 12,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell12
	}, {
	  id: 13,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell13
	}, {
	  id: 14,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell14
	}, {
	  id: 15,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell15
	}, {
	  id: 16,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell16
	}, {
	  id: 17,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell17
	}, {
	  id: 18,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell18
	}, {
	  id: 19,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell19
	}, {
	  id: 20,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell20
	}, {
	  id: 21,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell21
	}, {
	  id: 22,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell22
	}, {
	  id: 23,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell23
	}, {
	  id: 24,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell24
	}, {
	  id: 25,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell25
	}, {
	  id: 27,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell27
	}, {
	  id: 28,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell28
	}, {
	  id: 29,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell29
	}, {
	  id: 30,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell30
	}, {
	  id: 31,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell32
	}, {
	  id: 32,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell33
	}, {
	  id: 33,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell34
	}, {
	  id: 34,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell35
	}, {
	  id: 35,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell36
	}, {
	  id: 35,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell37
	}, {
	  id: 35,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell38
	}, {
	  id: 35,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell39
	}, {
	  id: 35,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell40
	}, {
	  id: 35,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell41
	}, {
	  id: 37,
	  title: "Winpe Forum Events images",
	  imgUrl: bii2
	}, {
	  id: 38,
	  title: "Winpe Forum Events images",
	  imgUrl: bii3
	}, {
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: iama1
	}, {
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: iama2
	}, {
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: iama3
	}];
	
	var winpeEventImages = [{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell31
	}, {
	  id: 1,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell1
	}, {
	  id: 2,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell2
	}, {
	  id: 3,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell3
	}, {
	  id: 4,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell4
	}, {
	  id: 5,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell5
	}, {
	  id: 6,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell6
	}, {
	  id: 7,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell7
	}, {
	  id: 8,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell8
	}, {
	  id: 9,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell9
	}, {
	  id: 10,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell10
	}, {
	  id: 11,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell11
	}, {
	  id: 12,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell12
	}, {
	  id: 13,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell13
	}, {
	  id: 14,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell14
	}, {
	  id: 15,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell15
	}, {
	  id: 16,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell16
	}, {
	  id: 17,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell17
	}, {
	  id: 18,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell18
	}, {
	  id: 19,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell19
	}, {
	  id: 20,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell20
	}, {
	  id: 21,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell21
	}, {
	  id: 22,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell22
	}, {
	  id: 23,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell23
	}, {
	  id: 24,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell24
	}, {
	  id: 25,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell25
	}, {
	  id: 27,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell27
	}, {
	  id: 28,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell28
	}, {
	  id: 29,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell29
	}, {
	  id: 30,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell30
	}];
	
	var winImages1 = [{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell32
	}, {
	  id: 1,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell36
	}, {
	  id: 2,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell34
	}, {
	  id: 3,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell35
	}, {
	  id: 4,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell33
	}];
	var winImages2 = [{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell40
	}, {
	  id: 1,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell41
	}];
	var winImages3 = [{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell37
	}, {
	  id: 1,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell38
	}, {
	  id: 2,
	  title: "Winpe Forum Events images",
	  imgUrl: Gell39
	}];
	
	var breakingintoinvestingImages = [
	// {
	//   id: 0,
	//   title: "Winpe Forum Events images",
	//   imgUrl: bii1,
	// },
	{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: bii2
	}, {
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: bii3
	}];
	
	var igniteAMAImages = [{
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: iama1
	}, {
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: iama2
	}, {
	  id: 0,
	  title: "Winpe Forum Events images",
	  imgUrl: iama3
	}];
	
	//https://winpeforum.com/assets/ignite/gallery_pics-01.jpg
	
	exports.allImages = allImages;
	exports.winpeEventImages = winpeEventImages;
	exports.winImages1 = winImages1;
	exports.winImages2 = winImages2;
	exports.winImages3 = winImages3;
	exports.breakingintoinvestingImages = breakingintoinvestingImages;
	exports.igniteAMAImages = igniteAMAImages;

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// const Dish15 = "http://winpeforum.com/assets/gelleryimages/JIT_1725.jpg"
	// const Dish16 = "http://winpeforum.com/assets/gelleryimages/JIT_1745.jpg"
	// const Dish20 = "http://winpeforum.com/assets/gelleryimages/JIT_1787.jpg"
	// const Dish24 = "http://winpeforum.com/assets/gelleryimages/JIT_1855.jpg"
	// const Dish31 = "http://winpeforum.com/assets/gelleryimages/JIT_1979.jpg"
	// const Dish39 = "http://winpeforum.com/assets/gelleryimages/JIT_2131.jpg"
	// const Dish40 = "http://winpeforum.com/assets/gelleryimages/JIT_2072.jpg"
	
	var Gell1 = "https://winpeforum.com/assets/gelleryimages/JIT_1760.png";
	var Gell2 = "https://winpeforum.com/assets/gelleryimages/JIT_1780.png";
	var Gell3 = "https://winpeforum.com/assets/gelleryimages/JIT_1802.png";
	var Gell4 = "https://winpeforum.com/assets/gelleryimages/JIT_1811.png";
	var Gell5 = "https://winpeforum.com/assets/gelleryimages/JIT_1847.png";
	var Gell6 = "https://winpeforum.com/assets/gelleryimages/JIT_1852.png";
	var Gell7 = "https://winpeforum.com/assets/gelleryimages/JIT_1866.png";
	var Gell8 = "https://winpeforum.com/assets/gelleryimages/JIT_1868.png";
	var Gell9 = "https://winpeforum.com/assets/gelleryimages/JIT_1870.png";
	var Gell10 = "https://winpeforum.com/assets/gelleryimages/JIT_1879.png";
	var Gell11 = "https://winpeforum.com/assets/gelleryimages/JIT_1887.png";
	var Gell12 = "https://winpeforum.com/assets/gelleryimages/JIT_1897.png";
	var Gell13 = "https://winpeforum.com/assets/gelleryimages/JIT_1899.png";
	var Gell14 = "https://winpeforum.com/assets/gelleryimages/JIT_1912.png";
	var Gell15 = "https://winpeforum.com/assets/gelleryimages/JIT_1915.png";
	var Gell16 = "https://winpeforum.com/assets/gelleryimages/JIT_1928.png";
	var Gell17 = "https://winpeforum.com/assets/gelleryimages/JIT_1931.png";
	var Gell18 = "https://winpeforum.com/assets/gelleryimages/JIT_1979.png";
	var Gell19 = "https://winpeforum.com/assets/gelleryimages/JIT_1981.png";
	var Gell20 = "https://winpeforum.com/assets/gelleryimages/JIT_2008.png";
	var Gell21 = "https://winpeforum.com/assets/gelleryimages/JIT_2014.png";
	var Gell22 = "https://winpeforum.com/assets/gelleryimages/JIT_2026.png";
	var Gell23 = "https://winpeforum.com/assets/gelleryimages/JIT_2034.png";
	var Gell24 = "https://winpeforum.com/assets/gelleryimages/JIT_2038.png";
	var Gell25 = "https://winpeforum.com/assets/gelleryimages/JIT_2039.png";
	// const Gell26 = "https://winpeforum.com/assets/gelleryimages/JIT_2072.png"
	var Gell27 = "https://winpeforum.com/assets/gelleryimages/JIT_2081.png";
	var Gell28 = "https://winpeforum.com/assets/gelleryimages/JIT_2082.png";
	var Gell29 = "https://winpeforum.com/assets/gelleryimages/JIT_2116.png";
	var Gell30 = "https://winpeforum.com/assets/gelleryimages/JIT_2124.png";
	var Gell31 = "https://winpeforum.com/assets/gelleryimages/JIT_1725.jpg";
	
	var gelleryImages = [{
		id: 0,
		title: "Winpe Forum Events images",
		imgUrl: Gell31
	}, {
		id: 1,
		title: "Winpe Forum Events images",
		imgUrl: Gell1
	}, {
		id: 2,
		title: "Winpe Forum Events images",
		imgUrl: Gell2
	}, {
		id: 3,
		title: "Winpe Forum Events images",
		imgUrl: Gell3
	}, {
		id: 4,
		title: "Winpe Forum Events images",
		imgUrl: Gell4
	}, {
		id: 5,
		title: "Winpe Forum Events images",
		imgUrl: Gell5
	}, {
		id: 6,
		title: "Winpe Forum Events images",
		imgUrl: Gell6
	}, {
		id: 7,
		title: "Winpe Forum Events images",
		imgUrl: Gell7
	}, {
		id: 8,
		title: "Winpe Forum Events images",
		imgUrl: Gell8
	}, {
		id: 9,
		title: "Winpe Forum Events images",
		imgUrl: Gell9
	}, {
		id: 10,
		title: "Winpe Forum Events images",
		imgUrl: Gell10
	}, {
		id: 11,
		title: "Winpe Forum Events images",
		imgUrl: Gell11
	}, {
		id: 12,
		title: "Winpe Forum Events images",
		imgUrl: Gell12
	}, {
		id: 13,
		title: "Winpe Forum Events images",
		imgUrl: Gell13
	}, {
		id: 14,
		title: "Winpe Forum Events images",
		imgUrl: Gell14
	}, {
		id: 15,
		title: "Winpe Forum Events images",
		imgUrl: Gell15
	}, {
		id: 16,
		title: "Winpe Forum Events images",
		imgUrl: Gell16
	}, {
		id: 17,
		title: "Winpe Forum Events images",
		imgUrl: Gell17
	}, {
		id: 18,
		title: "Winpe Forum Events images",
		imgUrl: Gell18
	}, {
		id: 19,
		title: "Winpe Forum Events images",
		imgUrl: Gell19
	}, {
		id: 20,
		title: "Winpe Forum Events images",
		imgUrl: Gell20
	}, {
		id: 21,
		title: "Winpe Forum Events images",
		imgUrl: Gell21
	}, {
		id: 22,
		title: "Winpe Forum Events images",
		imgUrl: Gell22
	}, {
		id: 23,
		title: "Winpe Forum Events images",
		imgUrl: Gell23
	}, {
		id: 24,
		title: "Winpe Forum Events images",
		imgUrl: Gell24
	}, {
		id: 25,
		title: "Winpe Forum Events images",
		imgUrl: Gell25
	},
	// {
	// 	id: 26,
	// 	title: "Winpe Forum Events images",
	// 	imgUrl: Gell26,
	// },
	{
		id: 27,
		title: "Winpe Forum Events images",
		imgUrl: Gell27
	}, {
		id: 28,
		title: "Winpe Forum Events images",
		imgUrl: Gell28
	}, {
		id: 29,
		title: "Winpe Forum Events images",
		imgUrl: Gell29
	}, {
		id: 30,
		title: "Winpe Forum Events images",
		imgUrl: Gell30
	}];
	
	exports.default = { gelleryImages: gelleryImages };
	module.exports = exports["default"];

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ConnectView = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(211);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _reactAddToCalendar = __webpack_require__(140);
	
	var _reactAddToCalendar2 = _interopRequireDefault(_reactAddToCalendar);
	
	var _gelleryImages = __webpack_require__(416);
	
	var _allGelleryImages = __webpack_require__(415);
	
	var _reactTabs = __webpack_require__(150);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	__webpack_require__(93);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/hero_slider_1.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/hero_slider.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/Winpe_Shine_banner_10_sep.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/hero_slider_3.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/Winpe_Ignite_banner_5_sep.jpg";
	var icon6 = "https://winpeforum.com/assets/elements/WinPE_Ignite_event_page_hero_omage.jpg";
	var icon7 = "https://winpeforum.com/assets/elements/WLSTheme2.png  ";
	var icon8 = "https://winpeforum.com/assets/elements/winpe-ally-banner.jpg";
	var iconp1 = "https://winpeforum.com/assets/elements/phone_slider_1.jpg";
	var iconp2 = "https://winpeforum.com/assets/elements/phone_slider_2.jpg";
	var iconp3 = "https://winpeforum.com/assets/elements/phone_slider_3.jpg";
	var iconp4 = "https://winpeforum.com/assets/elements/phone_slider_4.jpg";
	var iconp5 = "https://winpeforum.com/assets/elements/Winpe_Ignite_banner_5_sep_phone.jpg";
	var iconp6 = "https://winpeforum.com/assets/elements/WinPE_Ignite_event_page_hero_omage_phone.jpg";
	var iconp7 = "https://winpeforum.com/assets/elements/WLSTheme.png";
	var iconp8 = "https://winpeforum.com/assets/elements/winpe-ally-phone.jpg";
	var icon13 = "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png";
	var duration = 400;
	
	var ConnectView = exports.ConnectView = function (_React$Component) {
	  _inherits(ConnectView, _React$Component);
	
	  function ConnectView(args) {
	    _classCallCheck(this, ConnectView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 2) {
	          _this.setState({
	            slidesToShow: 2
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 3) {
	          _this.setState({
	            slidesToShow: 3
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.TabContent = [{
	      tabName: "All"
	    }, {
	      tabName: "Winpe Launch Event"
	    }, {
	      tabName: "Winpe Ignite Network - Feb' 20"
	    }, {
	      tabName: "Winpe Ignite Investors Social"
	    }, {
	      tabName: "Winpe ProClub Launch"
	    }, {
	      tabName: "Winpe Ignite Breaking Into Investing"
	    }, {
	      tabName: "Winpe Ignite Ask Me Anything"
	    }];
	    _this.heroslider = [{
	      imgUrl: icon7,
	      pageUrl: "https://winpeleadershipsummit.winpeforum.com/"
	    }];
	
	    _this.phoneheroslider = [{
	      imgUr: iconp6,
	      pageUrl: "#"
	    }, {
	      imgUr: iconp1,
	      pageUrl: "https://proclub.winpeforum.com/"
	    }, {
	      imgUr: iconp3,
	      pageUrl: "#"
	    }, {
	      imgUr: iconp2,
	      pageUrl: "#"
	    }, {
	      imgUr: iconp8,
	      pageUrl: "#"
	    }, {
	      imgUr: iconp7,
	      pageUrl: "https://winpeleadershipsummit.winpeforum.com/"
	    }];
	    return _this;
	  }
	
	  ConnectView.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  ConnectView.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  ConnectView.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var icon = { textOnly: "none" };
	    var items = [{ outlook: "Outlook" }, { apple: "iCal" }, { yahoo: "Yahoo!" }, { google: "Google" }];
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    var settingsing = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: 2,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    var settingsingRes = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    var settings5 = {
	      dots: true,
	      infinite: true,
	      speed: 200,
	      autoplay: false,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      autoplaySpeed: 3000,
	      arrows: true
	    };
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe | Diversity is Now | Upcoming Events",
	        image: icon13,
	        description: "View Winpe\u2019s calendar of events including Winpe flagship initiatives that span multiple formats to enable dialogue, networking and knowledge sharing in the private equity industry.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "events_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "events_section" },
	            _react2.default.createElement("div", { className: "events_content" }),
	            _react2.default.createElement(
	              "div",
	              { className: "event_mid_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "event_mid_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "event_mid_heading" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement(_Heading2.default, { title: "Winpe Event Calendar" })
	                  )
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  { href: "/event-calendar/" },
	                  _react2.default.createElement(
	                    "button",
	                    { style: { marginLeft: '16%', widht: '100%', backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                    _react2.default.createElement("i", { "class": "fa fa-calendar" }),
	                    " \xA0 \xA0View Yearly Event Planner"
	                  ),
	                  "  "
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "eventlist_listing eventlist_listing_new" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement("div", { className: "top_e_border" }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "8 OCTOBER 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "From Independent Director Proficiency Test to Board Appointment"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_blank", href: "https://forms.gle/bh8fg5LRmtchxSAPA" },
	                              "Register Now"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "4 SEPTEMBER 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "Decoding India's Labour Codes: A Boardroom Perspective"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_blank", href: "/WOBDecodingIndiasLabourCodes/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "SEPTEMBER 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe sheshines:",
	                            _react2.default.createElement("br", null),
	                            "Capital Discipline in 2026 \u2013 What gets funded now, what doesn't"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " Gurugram, Haryana"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_blank", href: "#" },
	                              "Coming Soon"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "1 AUGUST 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite: Workshop on Financial Modelling for Investment Decisions"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_blank", href: "/IgniteWorkshopOnFinancialModelling/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "31 JULY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "Topic: Independent Director\u2019s Dilemma:",
	                            _react2.default.createElement("br", null),
	                            "When to Escalate, When to Trust Management"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_blank", href: "/WinpeWOBIndependentDirectorsDilemma/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "2 JULY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe sheshines: The honest debrief - ",
	                            _react2.default.createElement("br", null),
	                            "What we got wrong on both sides of the table"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " Bangalore International Centre"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines2July2026/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "25 JUNE 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "Knowledge Session",
	                            _react2.default.createElement("br", null),
	                            "Topic: Mock Audit Committee with Mr. Subbu Subramaniam"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/WOBBoardroomSimulation/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "29 MAY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "Shareholder Misalignment: Who Does the Board Actually Serve?"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/WOBShareholderMisalignment/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "16 MAY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite: AI for Investors"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/IgniteSession16May2026/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "17 APRIL 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "Digital Personal Data Protection Act: Board-Level Perspective"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/WOBTheDPDPAct/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "31 MARCH 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Leadership Summit & Awards 2026"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Taj Lands End, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "https://winpeleadershipsummit.winpeforum.com/event-report-2026/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "21 FEBRUARY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite: PEVC Career Topic"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/IgniteSession21Feb2026/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "17 FEBRUARY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " Jaypee Vasant Continental, New Delhi"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines17Feb2026/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "13 FEBRUARY 2026"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Women on Boards:",
	                            _react2.default.createElement("br", null),
	                            "Self-Led Series - Aviation Crisis"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/WOBSelf-Led-Series-Session1/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "11 DECEMBER 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " Bangalore International Centre"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines11Dec2025/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "4 DECEMBER 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Board Excellence Training"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " Taj Lands End, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/WOBModule2EventReport/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "15 NOVEMBER 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite Career Talk Session"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/IgniteSession15Nov2025/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "6 NOVEMBER 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " A91 Partners Office, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines06Nov2025/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "24 SEPTEMBER 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Google office, Gurgaon"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines24Sep2025/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "11 SEPTEMBER 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Board Excellence Training"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          " Taj Lands End, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "https://winpeforum.com/WOBModule1EventReport/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "4 AUGUST 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Mentee Applications Closed ",
	                            _react2.default.createElement("br", null),
	                            "Winpe ProClub Mentorship Program"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Online"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "https://proclub.winpeforum.com/cohortVI" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement("div", { className: "list_date" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Ignite Career Talk Series"
	                          )
	                        ),
	                        _react2.default.createElement("div", { className: "list_t2" }),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "19 JULY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Decoding Culture Fit"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            "   ",
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/DecodingCultureFit/" },
	                              "Event Report"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "26 JULY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Crafting Impactful Resumes: Stand Out in 6 Seconds or Less"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            "   ",
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/CraftingImpactfulResumes/" },
	                              "Event Report"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "02 AUGUST 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Mastering the Interview: From Preparation to Presence"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            "   ",
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/MasteringTheInterview/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "19 JUNE 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Bangalore"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines19June2025/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "17 MAY 2025 "
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "PEVC Career Talk Series | Session 02",
	                            _react2.default.createElement("br", null),
	                            "Understanding PEVC Culture: Career Progression and Promotion Paths"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/PEVC-Career-Talk-Session2/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "20 MARCH 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Leadership Summit & Awards 2025"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Taj Lands End, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "https://winpeleadershipsummit.winpeforum.com/event-report-2025/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "FEBRUARY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Ignite Masterclass | Series 01"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            "   ",
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/WinpeIgniteMasterclassSeries01/" },
	                              "Event Report"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "13 FEBRUARY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "span",
	                              { style: { color: '#22316b' } },
	                              "Session 01"
	                            ),
	                            _react2.default.createElement("br", null),
	                            "Term Sheets: A Practical Guide to Negotiating Deals"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "20 FEBRUARY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "span",
	                              { style: { color: '#22316b' } },
	                              "Session 02"
	                            ),
	                            _react2.default.createElement("br", null),
	                            "Governance: Navigating complexities at PEVC backed companies Online"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 FEBRUARY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            _react2.default.createElement(
	                              "span",
	                              { style: { color: '#22316b' } },
	                              "Session 03"
	                            ),
	                            _react2.default.createElement("br", null),
	                            "Structuring Deals: Investment Instruments for PEVC Online"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "6 FEBRUARY 2025"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Jaypee Vasant Continental,",
	                          _react2.default.createElement("br", null),
	                          "Vasant Vihar, New Delhi"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/sheshines6Feb2025/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "14 DECEMBER 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "PEVC Career Talk Series | Session 01",
	                            _react2.default.createElement("br", null),
	                            "Navigating the Path to PEVC: Preparation and Experiences in the Industry"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Online"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/PEVC-Career-Talk-Session1/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 NOVEMBER 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Wink, Vivanta, Bengaluru"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/Sheshines28Nov2024/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "17 OCTOBER 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Motilal Oswal Tower, Prabhadevi, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines17Oct2024/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "7 AUGUST 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Delhi NCR"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines7Aug2024/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "15 JULY 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Mentee Applications Closed ",
	                            _react2.default.createElement("br", null),
	                            "Winpe ProClub Mentorship Program"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Online"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "https://proclub.winpeforum.com/cohortV" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "23 MAY 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Bangalore International Centre"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines23May2024/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "22 MARCH 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Leadership Summit & Awards 2024"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Taj Lands End, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "https://winpeleadershipsummit.winpeforum.com/event-report-2024/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "24 JANUARY 2024"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Delhi NCR"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/SheShines24Jan2024/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "13 OCTOBER 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/SheShines/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "22 SEPTEMBER 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Ask Me Anything with Ashley Menezes"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Delhi NCR"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/AskMeAnything/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "24 AUGUST 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Bangalore"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/SheShines/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "27 JULY 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Delhi NCR"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/sheshines27July2023/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "8 July 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite | Career Fair 2023"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Online"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/Career-Initiatives23/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "1 July 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite | Career Bootcamp"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Online"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	
	                                href: "/Career-Initiatives23/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 APRIL 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Leadership Summit & Awards 2023"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Four Seasons, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                target: "__blank",
	                                href: "https://winpeleadershipsummit.winpeforum.com/event-report/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "19 JANUARY 2023"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Jook Taproom, Indiranagar, Bangalore"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/SheShines19Jan2023/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "10 NOVEMBER 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "The Quorum Club, LowerParel, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/SheShines10Nov2022/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "25 AUGUST 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Hotel Andaz, Aerocity - Delhi"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/SheShines25Aug2022/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "30 JUNE 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Kaz\xE9, Bangalore"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/SheShines30June2022/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "18 JUNE 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Career Day"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/CareerDay/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "15 JUNE 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "ProClub Mentorship Program Cohort III Applications Closed"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "https://proclub.winpeforum.com/cohortIII"
	                              },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "21 APRIL 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "sheshines with Winpe: Networking event"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "The Quorum Club, LowerParel, Mumbai"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/SheShinesWithWinPE/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "8 MARCH 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "What are the funds doing to increase diversity within and their portfolio companies",
	                            _react2.default.createElement("br", null),
	                            "@ IVCA Conclave 2022"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/ivcaconclave2022/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "DECEMBER 2021 - MARCH 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Alicorn Leadership Summit 2021-22"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "https://winpeleadershipsummit.winpeforum.com/home/" },
	                              "View Details"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "16 DECEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Session 1: Leaders Today, Icons Tomorrow"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 JANUARY 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Session 2: Global Perspectives: Diversity in Leadership"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "1 MARCH 2022"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Session 3: Investing for the Future"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "8 JANUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\"Wharton India Economic Forum 2022 | Panel discussion on \"Bridging the talent gap\" "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/WhartonIndiaEconomicForum" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "3 DECEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " The 2nd edition of D2C Summit - Fireside chat on Why India's $100 Bn D2C Economy needs a Sustainable Approach "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/D2CSummit" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "OCTOBER - DECEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "  Industry Disruption 2.0 with UN Women "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/Industry-Dirupton-2" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "ONGOING, FORTNIGHTLY"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Workshop with Women in Investing"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/women-in-investing" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "2 NOVEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Asia Gender-Smart Investing Forum \u2014 \u201CIntroduction to Gender Smart Investment Tools and Frameworks\u201D "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/Asia-Gender-Smart-Investing-Forum" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "30 OCTOBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Driving Gender Balance among Enterprise Founders and Investors "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/Driving-Gender-Balance" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "22 OCTOBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Ally Network - Pilot | Multi Group Meet "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/ally-network" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "18 OCTOBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe ProClub Mentorship Program: Workshop with Mentors Cohort II"
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "https://proclub.winpeforum.com/events/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "7 OCTOBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Maximum India Conclave #MIC 2021 - Fireside Chat: \"Corporate Governance for PEVC in India | The Good and The Better"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/IVCA-MIC2021" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "6 OCTOBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe ProClub Mentorship Program: Workshop with Mentees Cohort II"
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "https://proclub.winpeforum.com/events/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "29 SEPTEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Collegium"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/winpe-collegium-sep-2021" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 SEPTEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe ProClub Mentorship Program: Launch Event Cohort II"
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "https://proclub.winpeforum.com/events/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "25 SEPTEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Ignite Career Conversations | A Day as an Investment Analyst"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/CareerConversations" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "AUGUST 2021 - SEPTEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Edge: Masterclass Series with Trilegal"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/winpe-edge-masterclass-series-with-trilegal/" },
	                              "Event Report"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "7 AUGUST 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Term Sheets"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "21 AUGUST 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Due Diligence Including Considerations for Start Ups and ESG"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "4 SEPTEMBER 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "M&A; Exit Strategies"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "2 AUGUST 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Ally Network: Launch Meeting"
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          " Members Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/ally-network" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "26 JUNE 2021 - 26 JULY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Ally Network - Pilot"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/ally-network" },
	                              "View Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "22 JULY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Winpe Collegium"
	                          ),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/winpe-collegium" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "10 JULY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Build the Brand U ",
	                            _react2.default.createElement("br", null),
	                            "Winpe Shine Leadership Development Series"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/build-brand-u" },
	                              " Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "6 JULY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Gender Lens Investing: Experiences So Far and Way Ahead - Panel Discussion @ 2nd IVCA Impact and Sustainable Investment Conference"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "/IVCA-Impact-and-Sustainable-Investment-Conference" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "2 JULY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite: Campus Connect at SPJIMR"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/ignite-campus-connect" },
	                              " Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "15 JUNE 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Mentee Applications Closed ",
	                            _react2.default.createElement("br", null),
	                            "Winpe ProClub Mentorship Program"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "https://proclub.winpeforum.com/cohortII" },
	                              "See Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "MAY 2021 - JUNE 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite Career Bootcamp"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/careerbootcamp/" },
	                              "Event Report"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "29 MAY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Panel Discussion with Recent Hires on Getting that Investing Job"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "5 JUNE 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " Recruiters' Insights on How to Make a Good CV"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "12 JUNE 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Mock Interview Panel"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement("div", { className: "list_t3" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "21 MAY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " ProClub Dialogues (By Invite Only)"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { target: "_BLANK", href: "https://proclub.winpeforum.com/events/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "22 APRIL 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Collegium"
	                          ),
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/firstcollegium2021" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "20 MARCH 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite ",
	                            _react2.default.createElement("br", null),
	                            "Ask Me Anything"
	                          ),
	                          _react2.default.createElement("br", null)
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/ignite-askmeanything/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "19 MARCH 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Scaling Up Diversity in Startups",
	                            _react2.default.createElement("br", null),
	                            "@ IVCA Conclave 2021"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                // target="__blank"
	                                href: "/ivcaconclave2021/"
	                              },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "27 FEBRUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "KPMG Ideation Challenge"
	                          ),
	                          _react2.default.createElement("br", null)
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                target: "__blank",
	                                href: "https://home.kpmg/in/en/home/careers/graduates/kpmg-ideation-challenge-kic.html"
	                              },
	                              "Event Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "19 FEBRUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Women in Investing ",
	                            _react2.default.createElement("br", null),
	                            "Oxford Seed Fund"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                target: "__blank",
	                                href: "https://eship.ox.ac.uk/event/women-in-investing-with-oxford-seed-fund/"
	                              },
	                              "Event Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "DECEMBER 2020 - FEBRUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "The Alicorn Leadership Summit",
	                            _react2.default.createElement("br", null),
	                            "Winpe Anniversary Celebrations"
	                          )
	                        ),
	                        _react2.default.createElement("div", { className: "list_t2" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://winpeleadershipsummit.winpeforum.com/home/",
	                                target: "_blank"
	                              },
	                              "Visit Website"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "18 FEBRUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Unlocking the Power of Diversity"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://winpeleadershipsummit.winpeforum.com/past-events/",
	                                target: "_blank"
	                              },
	                              "View Recording"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "21 JANUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Upping the Stakes"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://winpeleadershipsummit.winpeforum.com/past-events/",
	                                target: "_blank"
	                              },
	                              "View Recording"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "10 DECEMBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Scale Of Success"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://winpeleadershipsummit.winpeforum.com/past-events/",
	                                target: "_blank"
	                              },
	                              "View Recording"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 JANUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Collegium"
	                          ),
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/fourthcollegium/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "16 JANUARY 2021"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Startup India \u2013 The Way Ahead ",
	                            _react2.default.createElement("br", null),
	                            "Prarambh: Startup India International Summit"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                target: "__blank",
	                                href: "https://www.theprarambh.in/agenda.html"
	                              },
	                              "Event Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 NOVEMBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite ",
	                            _react2.default.createElement("br", null),
	                            " Breaking into Investing"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/breakingintoinvesting/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "7 NOVEMBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Shattering Glass Ceilings",
	                            _react2.default.createElement("br", null),
	                            "Wharton India Economic Forum"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://www.whartonindia.com/",
	                                target: "__blank"
	                              },
	                              "Event Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "7 NOVEMBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "The Art and Science of Public Speaking ",
	                            _react2.default.createElement("br", null),
	                            "Winpe Shine Leadership Development Series"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/toastmasters/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "6 OCTOBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            " ",
	                            "Winpe ProClub Mentorship Program: Launch"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://proclub.winpeforum.com/home/",
	                                target: "_blank"
	                              },
	                              "See Details"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "30 SEPTEMBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Collegium"
	                          ),
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/winpecollegiumSeptember/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "5 SEPTEMBER 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite Investors Social"
	                          ),
	                          _react2.default.createElement("br", null)
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/wiisocial/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "27 AUGUST 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Building Strategic Networks ",
	                            _react2.default.createElement("br", null),
	                            "Winpe Shine Leadership Development Series"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/wsldsnetworkingeventreport/" },
	                              "Event Report"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/wsldsnetworking/" },
	                              "Workshop Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "18 JUNE 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Collegium"
	                          ),
	                          _react2.default.createElement("br", null),
	                          " By Invite Only"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/winpecollegium/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "26, 27, 28 MAY 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Bragging with Grace for Impact ",
	                            _react2.default.createElement("br", null),
	                            "Winpe Shine Leadership Development Series"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/wsldseventreport/" },
	                              "Event Report"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/winpeshineprogram/" },
	                              "Workshop Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "24 APRIL 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe & PwC Webcast on Impact of the revised FDI policy"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/pwcwebcast/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "03 APRIL 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe x Trilegal Webinar on COVID19: Impact on Deals & Contracts",
	                            " "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/trilegarWebinar/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "08 MARCH 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Celebrating Women in Investing | Video Series for International Women's Day"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "ONLINE"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/womensdayeventreport/" },
	                              "Event Report"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/iwdvideoseries/" },
	                              "Video Series"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "28 FEBRUARY 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe Ignite Network (WIN) "
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "MUMBAI"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/wineventreport/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "17 FEBRUARY 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Celebrating Success - Women in Investing: Winpe @ IVCA Conclave 2020"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "Delhi NCR"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              "a",
	                              {
	                                href: "https://ivcaconclave.com/agenda/",
	                                target: "_blank"
	                              },
	                              "Event Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "07 FEBRUARY 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Maiden Winpe Collegium"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "MUMBAI"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/maidenCollegium/" },
	                              "Event Report"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 col-sm-12 col-xs-12" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "list_card" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_date" },
	                          "07 FEBRUARY 2020"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t1" },
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Winpe : Launching the Dialogue"
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t2" },
	                          "MUMBAI"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_t3" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box2" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/launchreport/" },
	                              "Event Report"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "list_t3_box1" },
	                            _react2.default.createElement(
	                              _gatsbyLink2.default,
	                              { to: "/launchagenda/" },
	                              "Event Agenda"
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "gellery_section" },
	              _react2.default.createElement(
	                "div",
	                { className: "gellery_content" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "gellery_heading" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "" },
	                    _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "gellery_list" },
	                  _react2.default.createElement(
	                    _reactTabs.Tabs,
	                    null,
	                    _react2.default.createElement(
	                      _reactTabs.TabList,
	                      null,
	                      this.TabContent.map(function (item, l) {
	                        return _react2.default.createElement(
	                          _reactTabs.Tab,
	                          null,
	                          item.tabName
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings,
	                          _allGelleryImages.allImages.map(function (item, j) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "gellery_card", key: j },
	                              _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings,
	                          _allGelleryImages.winpeEventImages.map(function (item, k) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "gellery_card", key: k },
	                              _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings,
	                          _allGelleryImages.winImages1.map(function (item, p) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "gellery_card", key: p },
	                              _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        _reactResponsive2.default,
	                        { query: "(min-width: 768px)" },
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _allGelleryImages.winImages2.map(function (item, q) {
	                              return _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-4 col-md-6" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "gellery_carddd", key: q },
	                                  _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                                )
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _reactResponsive2.default,
	                        { query: "(max-width: 767px)" },
	                        _react2.default.createElement(
	                          "div",
	                          null,
	                          _react2.default.createElement(
	                            _reactSlick2.default,
	                            settingsingRes,
	                            _allGelleryImages.winImages2.map(function (item, q) {
	                              return _react2.default.createElement(
	                                "div",
	                                { className: "gellery_cardd", key: q },
	                                _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                              );
	                            })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings,
	                          _allGelleryImages.winImages3.map(function (item, w) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "gellery_card", key: w },
	                              _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactResponsive2.default,
	                          { query: "(min-width: 768px)" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              "div",
	                              { className: "row" },
	                              _allGelleryImages.breakingintoinvestingImages.map(function (item, q) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "col-lg-4 col-md-6" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "gellery_carddd", key: q },
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.title
	                                    })
	                                  )
	                                );
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _reactResponsive2.default,
	                          { query: "(max-width: 767px)" },
	                          _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                              _reactSlick2.default,
	                              settingsingRes,
	                              _allGelleryImages.breakingintoinvestingImages.map(function (item, q) {
	                                return _react2.default.createElement(
	                                  "div",
	                                  { className: "gellery_cardd", key: q },
	                                  _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                                );
	                              })
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactTabs.TabPanel,
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings,
	                          _allGelleryImages.igniteAMAImages.map(function (item, w) {
	                            return _react2.default.createElement(
	                              "div",
	                              { className: "gellery_card", key: w },
	                              _react2.default.createElement("img", { src: item.imgUrl, alt: item.title })
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ConnectView;
	}(_react2.default.Component);
	
	ConnectView.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = ConnectView;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-index-js-a29f0bf142445034f26a.js